import React, { Component } from 'react';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { Input } from '@progress/kendo-react-inputs';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { connect } from 'react-redux';
import { fetchParentCommittees } from '../../../../../Redux/Actions/Admin/ManageCommitteeAction';
import axios from 'axios'
import { ROOT_API_URL } from '../../../../../api-config';
import { auth } from '../../../../../services/auth.service';

class CommitteeForm extends Component {
	constructor(props) {
		super(props);
		this.state = {
            committeeInEdit: this.props.dataItem || null,
            originalCommitteeName: this.props.dataItem.Name || '',
            originalAcronym: this.props.dataItem.Acronym || '',
            value: [],
            nameMessage: '',
            acronymMessage: ''
		};
	}

	componentDidMount() {
		this.props.fetchParentCommittees();
	}

    handleSubmit = (event) => {
        event.preventDefault();
        axios
			.get(`${ROOT_API_URL}/ManageCommittee/CheckDuplicateCommittee?committeeName=${this.state.committeeInEdit.Name}`, { headers: auth.authHeader() })
            .then((response1) => {
                axios
					.get(`${ROOT_API_URL}/ManageCommittee/CheckDuplicateAcronym?acronym=${this.state.committeeInEdit.Acronym}`, { headers: auth.authHeader() })
					.then((response2) => {
						let t1 = this.state.originalAcronym;
						let t2 = this.state.committeeInEdit.Acronym;
                        if (this.state.originalAcronym != this.state.committeeInEdit.Acronym) {
                            this.setState({
                                acronymMessage: response2.data.message
                            });
                        }
                        if (this.state.originalCommitteeName != this.state.committeeInEdit.Name) {
                            this.setState({
                                nameMessage: response1.data.message
                            });
                        }

						if (this.state.nameMessage == "" && this.state.acronymMessage == "") {
                            if (this.state.committeeInEdit.CommitteeId != undefined) {
                                this.props.updateCommittee(this.state.committeeInEdit);

                            } else {
                                this.props.addCommittee(this.state.committeeInEdit);
                            }
                        }
                    })
                    .catch((response2) => {
                        console.log(response2);
                    });
            })
            .catch((response1) => {
                console.log(response1);
            });        
	};
	isCustom(item) {
		return item.id === undefined;
	}
	addKey(item) {
		item.id = new Date().getTime();
    }

	onDialogInputChange = (event) => {
        let target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        let name = target.props ? target.props.name : target.name;
		name = name.charAt(0).toUpperCase() + name.slice(1);
		let edited = JSON.parse(JSON.stringify(this.state.committeeInEdit));
        edited[name] = value;
        edited.isActive = true;

        if (name == "name") {
            this.setState({
                committeeInEdit: edited,
                nameMessage: ''
            });
        }
        else {
            this.setState({
                committeeInEdit: edited,
                acronymMessage: ''
            });
        }
        
    };
    
	onCommitteeTypeChange = (event) => {
		const value = event.target.value;
        const edited = JSON.parse(JSON.stringify(this.state.committeeInEdit));
		edited.CommitteeTypeId = value.committeeTypeId;
		edited.CommitteeType = { description: value.description, committeeTypeId: value.committeeTypeId }
		edited.PositionGroup = null;
		this.setState({
			committeeInEdit: edited
		});
	}
	handleParentCommitteeChange = (event) => {
		let value = event.target.value;
		const edited = JSON.parse(JSON.stringify(this.state.committeeInEdit));
		edited.ParentCommitteeId = value.parentCommitteeId;
		edited.ParentCommittee = { name: value.name, id: value.id }
		this.setState({
			committeeInEdit: edited
		});
	}
    
	handlePostionGroupChange = (event) => {
        let value = event.target.value;
        const edited = JSON.parse(JSON.stringify(this.state.committeeInEdit));
		edited.PositionGroupId = value.positionGroupId;
		edited.PositionGroup = { description: value.description, positionGroupId: value.positionGroupId}
		this.setState({
			committeeInEdit: edited
		});
	}

	render() {
		return (
			<div className="committeeForm">
                {!this.state.committeeInEdit.CommitteeId ?
                    <h2 className="edit-committe-title">Add New Committee</h2> :
                    <h2 className="edit-committe-title">Edit Committee</h2>}
				<form className="user-form adjusting" onSubmit={this.handleSubmit}>
					<div className="form-group col-md-6 col-lg-4">
						<label htmlFor="name">Committee Name</label>
						<Input
							required={true}
							type="text"
							name="name"
							id="name"
							value={this.state.committeeInEdit.Name || ''}
                            onChange={this.onDialogInputChange}
                        />
                        <p className="error-message">{this.state.nameMessage}</p>
					</div>
					<div className="form-group col-md-6 col-lg-4">
                        <label htmlFor="acronym">Acronym</label>
						<Input
							required={true}
							type="text"
							name="acronym"
							id="acronym"
							value={this.state.committeeInEdit.Acronym || ''}
                            onChange={this.onDialogInputChange}
                        />
                        <p className="error-message">{this.state.acronymMessage}</p>
					</div>
					{/* <div className="form-group col-md-6 col-lg-4">
                        <label htmlFor="parentCommittee">Parent Committee</label>
						<DropDownList  
							data={this.props.parentCommittees}
							onChange={this.handleParentCommitteeChange}
							value={this.state.committeeInEdit.ParentCommittee}
							textField="name"
							dataItemKey="id"
							allowCustom={true}
							name="parentCommittee"
							id="parentCommittee"
						/>
					</div> */}
					<div className="form-group col-md-6 col-lg-4">
                        <label htmlFor="committeeType">Committee Type</label>
                        <DropDownList 
                            required={true}
							data={this.props.committeeTypes}
							onChange={this.onCommitteeTypeChange}
							value={this.state.committeeInEdit.CommitteeType}
							textField="description"
							dataItemKey="committeeTypeId"
							allowCustom={true}
							name="committeeType"
							id="committeeType"
						/>
					</div>
					{this.state.committeeInEdit.CommitteeType ?
						<div className="form-group col-md-6 col-lg-4">
							<label htmlFor="positionGroup">Position Group</label>
							<DropDownList
								required={true}
								data={this.props.positionGroups}
								onChange={this.handlePostionGroupChange}
								value={this.state.committeeInEdit.PositionGroup}
								textField="description"
								dataItemKey="positionGroupId"
								allowCustom={true}
								name="positionGroup"
								id="positionGroup"
							/>
						</div>
						:""}
                    <div className="footer col-md-12 edit-cmt-btns">
						<div className="form-group">
							<button className="admin-k-button" onClick={this.props.cancel}>
								<i className="fas fa-times"></i>
								<span>CANCEL</span>
							</button>
							{/* {console.log('this.state.userInEdit', this.state.userInEdit)} */}
							{!this.state.committeeInEdit.CommitteeId ? (
								<button type="submit" className="admin-k-button">
									<i className="fas fa-save"></i>
									<span>SAVE</span>
								</button>
							) : (
								<button type="submit" className="admin-k-button update-btn">
									<i className="fas fa-edit"></i>
									<span>UPDATE</span>
								</button>
							)}
						</div>
					</div>
				</form>
            </div>
		);
	}
}

export default connect(null, { fetchParentCommittees })(CommitteeForm);
